import { fadeIn } from '../../utils/utils';
import './author.scss';

(function () {
    const buttonCollection = document.querySelectorAll('.js-author-button');
    const authorDescriptions = document.querySelectorAll('.js-author-description');

    changeTab(1, buttonCollection[0]);

    buttonCollection.forEach(($button) => {
        console.log($button);
        const buttonNumber = $button.getAttribute('data-button-number');

        $button.addEventListener('click', changeTab.bind(this, buttonNumber, $button));
    });

    function changeTab(tabNumber, $button) {
        buttonCollection.forEach(($button) => {
            $button.classList.remove('is-active');
        });

        $button.classList.add('is-active');

        authorDescriptions.forEach((item) => {
            item.style.display = 'none';
        });

        fadeIn(authorDescriptions[tabNumber - 1], 500);
    }
})();
